module.exports = __webpack_public_path__ + "static/media/senses-lounge.55f27a94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sites/senses-lounge.png
// module id = 331
// module chunks = 0